import { TableColumn } from '../../../components/DataTable/TableColumn';
import { TextColumn } from '../../../components/DataTable/TextColumn';
import { DateColumn } from '../../../components/DataTable/DateColumn';
import { N11Order } from '../../../interfaces/N11/N11Order';
import { N11ProductsCell } from './N11ProductsCell';
import { N11StatusCell } from './N11StatusCell';
import { Pagination } from '../../../interfaces/Pagination';
import { DataTable } from '../../../components/DataTable/DataTable';

const columns: TableColumn<N11Order>[] = [
  {
    id: 'n11-id',
    name: 'N11 ID',
    accessor: (row) => <TextColumn value={row.n11ID} />,
  },
  {
    id: 'products',
    name: 'Ürünler',
    accessor: (row) => <N11ProductsCell order={row} />,
  },
  {
    id: 'status',
    name: 'Durum',
    align: 'center',
    accessor: (row) => <N11StatusCell status={row.status} />,
  },
  {
    id: 'created-at',
    name: 'Sipariş Tarihi',
    accessor: (row) => <DateColumn value={row.createdAt} />,
  },
];

type N11OrdersTableProps = {
  orders: N11Order[];
  totalCount: number;
  pagination: Pagination;
  onPagination: (newPagination: Pagination) => void;
};

export const N11OrdersTable = (props: N11OrdersTableProps) => {
  return (
    <DataTable
      columns={columns}
      totalCount={props.totalCount}
      rows={props.orders}
      limit={props.pagination.pageSize}
      setLimit={(newLimit) =>
        props.onPagination({ page: 0, pageSize: newLimit })
      }
      page={props.pagination.page}
      setPage={(newPage) =>
        props.onPagination({ ...props.pagination, page: newPage })
      }
    />
  );
};
